module.exports = __webpack_public_path__ + "img/3.15e2c93b.png";